import React from 'react';
import { 
  Zap, BadgePercent, ShieldCheck, 
  MapPin, Headphones, Star 
} from 'lucide-react';

const WhyChoose = () => {
  const features = [
    {
      icon: Zap,
      title: "Instant Booking",
      desc: "Fast, seamless hotel reservations confirmed in seconds with direct hotel sync.",
      color: "#0d6efd",
      bg: "rgba(13, 110, 253, 0.08)"
    },
    {
      icon: BadgePercent,
      title: "Best Price Guarantee",
      desc: "Honest rates with exclusive seasonal coupons and zero hidden checkout fees.",
      color: "#10b981",
      bg: "rgba(16, 185, 129, 0.08)"
    },
    {
      icon: ShieldCheck,
      title: "100% Safe Payments",
      desc: "Bank-grade encrypted transactions via Razorpay, UPI, RuPay, Cards & NetBanking.",
      color: "#f59e0b",
      bg: "rgba(245, 158, 11, 0.08)"
    },
    {
      icon: MapPin,
      title: "Verified Accommodations",
      desc: "Only genuine, physically verified hotels and resorts with truthful room photos.",
      color: "#8b5cf6",
      bg: "rgba(139, 92, 246, 0.08)"
    },
    {
      icon: Headphones,
      title: "24/7 Dedicated Support",
      desc: "Live travel specialists ready around the clock to assist your plans.",
      color: "#06b6d4",
      bg: "rgba(6, 182, 212, 0.08)"
    },
    {
      icon: Star,
      title: "Loved by Travelers",
      desc: "Consistently rated 4.9★ by thousands of delighted explorers across India.",
      color: "#ec4899",
      bg: "rgba(236, 72, 153, 0.08)"
    },
  ];

  return (
    <section className="why-choose-section py-5 bg-light position-relative">
      <div className="container py-3">
        <div className="text-center mx-auto mb-5" style={{ maxWidth: '640px' }}>
          <span className="badge rounded-pill px-3 py-1.5 mb-2 fw-semibold text-primary" style={{ backgroundColor: 'rgba(13, 110, 253, 0.1)', fontSize: '12px' }}>
            WHY TRAVEL WITH US
          </span>
          <h2 className="display-6 fw-bold text-dark mb-2">Why Choose ZoyoTrip?</h2>
          <p className="text-muted fs-6 mb-0">Your ultimate Indian travel companion — smart, safe & delightfully simple.</p>
        </div>

        <div className="row g-4">
          {features.map((item, index) => {
            const IconComp = item.icon;
            return (
              <div className="col-md-4 col-sm-6" key={index}>
                <div 
                  className="p-4 rounded-4 bg-white border h-100 transition hover-lift text-center text-sm-start d-flex flex-column"
                  style={{
                    borderColor: '#e2e8f0',
                    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.02)'
                  }}
                >
                  <div 
                    className="d-inline-flex align-items-center justify-content-center rounded-3 p-3 mb-3 mx-auto mx-sm-0"
                    style={{ backgroundColor: item.bg, color: item.color, width: '48px', height: '48px' }}
                  >
                    <IconComp size={22} />
                  </div>
                  <h5 className="fw-bold text-dark mb-2">{item.title}</h5>
                  <p className="text-muted small mb-0 lh-base flex-grow-1">{item.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <style>{`
        .hover-lift {
          transition: transform 0.25s ease, box-shadow 0.25s ease;
        }
        .hover-lift:hover {
          transform: translateY(-3px);
          box-shadow: 0 10px 24px rgba(0, 0, 0, 0.06) !important;
        }
      `}</style>
    </section>
  );
};

export default WhyChoose;